import { createFileRoute } from "@tanstack/react-router";
import WhatIsAcceleratedTmsPage from "@/pages/learn/WhatIsAcceleratedTmsPage";
import { pageWhatIsAcceleratedTms } from "@/pages/learn/learnDataWhatIsAcceleratedTms";

export const Route = createFileRoute("/what-is-accelerated-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: `${pageWhatIsAcceleratedTms.title} | Neuro Wellness`,
        },
        {
          name: "description",
          content: pageWhatIsAcceleratedTms.description,
        },
        {
          property: "og:title",
          content: `${pageWhatIsAcceleratedTms.title} | Neuro Wellness`,
        },
        {
          property: "og:description",
          content: pageWhatIsAcceleratedTms.description,
        },
        {
          property: "og:url",
          content: `https://neurowellnesstms.com${pageWhatIsAcceleratedTms.canonical}`,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: `https://neurowellnesstms.com${pageWhatIsAcceleratedTms.canonical}`,
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageWhatIsAcceleratedTms.schemaJson),
        },
      ],
    };
  },
});

function RouteComponent() {
  return <WhatIsAcceleratedTmsPage />;
}
